<template>
  <main class="addExams">
    <div class="addExams__message">
      <div class="message__icon icon-circle">
        <AttendantSvg class="message__icon--hospital" />
      </div>

      <div class="message__text">
        <h1 class="text__title">
          Para adicionar serviços você precisará ir para o guichê de atendimento
        </h1>
        <p class="text__info">
          Vamos utilizar as informações preenchidas para adiantar seu atendimento. Na unidade
          adicione seus exames com um de nossos atendentes.
        </p>
      </div>
    </div>

    <div class="button__group">
      <VButton text="Continuar" variant="secondary" @click.native="goToNextPage" />
    </div>
  </main>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'addExamsServiceDesk',
  mixins: [dataLayersMixin],

  mounted() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Atendimento no guichê',
    });
  },
  methods: {
    ...mapActions({
      setAdmissionNotElegible: 'setAdmissionNotElegible',
    }),
    ...mapMutations({
      setAdmissionAuthorization: 'SET_ADMISSION_AUTHORIZATION',
    }),
    async goToNextPage() {
      await this.setAdmissionAuthorization(false);
      await this.setAdmissionNotElegible();
      this.goNextStep('questions_step');
    },
  },
};
</script>

<style lang="scss" scoped>
.addExams {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  &__message {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-content: center;
    align-items: center;
    max-width: 80%;

    .message {
      &__icon {
        &--hospital {
          fill: var(--color-primary);
          height: 36px;
        }
      }

      &__text {
        .text__title {
          color: #161616;
          font-weight: bold;
          padding: 24px 0 12px 0;
        }
      }
    }
  }

  .icon-circle {
    width: 72px;
    height: 72px;
  }

  .button__group {
    button {
      margin-bottom: 16px;
      background-color: var(--color-primary);
      border-color: var(--color-primary);
      color: #fff;

      &:nth-child(2) {
        background-color: transparent;
        color: var(--color-primary);
        border-color: transparent;
      }
    }
  }
}
</style>
